import { render } from "./WatchButtonProcedure.vue?vue&type=template&id=76ac5a63&scoped=true"
import script from "./WatchButtonProcedure.vue?vue&type=script&lang=js"
export * from "./WatchButtonProcedure.vue?vue&type=script&lang=js"

import "./WatchButtonProcedure.vue?vue&type=style&index=0&id=76ac5a63&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ac5a63"]])

export default __exports__